export enum BatchRolesProdEnum {
  BF_PLT_ENG = 'LTL_BATCH_FRAMEWORK_PLT_ENG',
  BF_DCX = 'LTL_BATCH_FRAMEWORK_DCX',
  BF_LEAD = 'LTL_BATCH_FRAMEWORK_LEAD_TECH',
  BF_DEV = 'LTL_BATCH_FRAMEWORK_DEV',
  BF_ADMIN = 'LTL_BATCH_FRAMEWORK_ADMIN',
}
